import React from 'react';

const PricingSummary = ({ pricing, programData, optionsData }) => {
  const formatPrice = (price) => {
    return new Intl.NumberFormat('fr-FR').format(price);
  };

  const totalGroups = programData.groups.length;
  const totalLearners = pricing.days_breakdown.total_learners;
  const totalModuleInstances = pricing.days_breakdown.total_module_instances;

  return (
    <div className="bg-white border border-[#d8dde5] rounded-lg p-6 h-full flex flex-col" data-testid="pricing-summary">
      <h3 className="text-left mb-6">Programme de formation en management</h3>
      
      {/* Données du programme */}
      <div className="space-y-2 mb-6">
        <div className="flex justify-between">
          <span>Nb d'apprenants :</span>
          <span className="font-medium">{totalLearners}</span>
        </div>
        <div className="flex justify-between">
          <span>Nb de groupe :</span>
          <span className="font-medium">{totalGroups}</span>
        </div>
        <div className="flex justify-between">
          <span>Nb de module :</span>
          <span className="font-medium">{totalModuleInstances}</span>
        </div>
      </div>

      {/* Sous-total programme */}
      <div className="flex justify-between pb-2 mb-6 border-b border-[#d8dde5]">
        <span className="font-medium">Sous-total du programme :</span>
        <span className="font-medium">{formatPrice(pricing.program_price)} € HT</span>
      </div>

      <h3 className="text-left mb-4">Les options</h3>
      
      {/* Options sélectionnées */}
      <div className="space-y-2 mb-4">
        {pricing.options_breakdown.breakdown && Object.keys(pricing.options_breakdown.breakdown).length > 0 ? (
          Object.entries(pricing.options_breakdown.breakdown).map(([optionName, price]) => (
            <div key={optionName} className="flex justify-between">
              <span>{optionName}</span>
              <span className="font-medium">{formatPrice(price)} € HT</span>
            </div>
          ))
        ) : (
          <div className="flex justify-between text-[#647687] italic">
            <span>Aucune option sélectionnée</span>
            <span>0 € HT</span>
          </div>
        )}
      </div>

      {/* Sous-total options */}
      <div className="flex justify-between pb-2 mb-6 border-b border-[#d8dde5]">
        <span className="font-medium">Sous-total options :</span>
        <span className="font-medium">{formatPrice(pricing.options_price)} € HT</span>
      </div>

      {/* Total */}
      <div className="flex justify-between items-center pt-2">
        <span className="text-xl font-bold">TOTAL* :</span>
        <span className="text-xl font-bold text-[#fa6800]">
          {formatPrice(pricing.total_price)} € HT
        </span>
      </div>
      
      <p className="text-left text-xs italic text-[#647687] mt-3">
        * ce prix est estimatif, il doit être confirmé par un responsable pédagogique.
      </p>
    </div>
  );
};

export default PricingSummary;